import React, { useEffect } from 'react';

function Dot({ isSelected, id, onClick, isMobile = false }) {
    return (
        <>
            <style type="text/css">
                {`
                    #dot-${id} {
                        background: ${isSelected ? '#E85B00' : '#FFFFFF'};
                        border-radius: 50%;
                        cursor: pointer;
                        height: ${isMobile ? '10px' : '12px'};
                        min-width: ${isMobile ? '10px' : '12px'};
                        display: inline-block;
                        margin-right: 24px;
                    }
                `}
            </style>
            <span
                id={`dot-${id}`}
                onClick={onClick}
            />
        </>
    );
}

function DotIndicator({
    totalSlides,
    currentSlideIndex,
    clickToSlide = () => {},
    loadSlide = () => {},
    perSlide = 1,
    onDotIndicatorClick = () => {},
    isMobile = false,
}) {
    const dots = [];
    const maxDots = Math.ceil(totalSlides / perSlide);

    for (let i = 0; i < maxDots; i++) {
        dots.push(i);
    }

    useEffect(() => {
        loadSlide();
    }, [currentSlideIndex]);

    return (
        <div
            className="dot-indicators"
            data-automation="dot-indicators"
        >
            {dots.map((i) => (
                <Dot
                    onClick={(e) => {
                        e.preventDefault();
                        clickToSlide(i);
                        if (onDotIndicatorClick) onDotIndicatorClick(i);
                    }}
                    isSelected={currentSlideIndex === i}
                    data-index={i}
                    id={i}
                    key={i}
                    isMobile={isMobile}
                />
            ))}
        </div>
    );
}

export default DotIndicator;
